export const environment = {
    production: true,
    api: "api.distro-beat.com",
    cookieDomain: "distro-beat.com",
    https: true,
};
